import React, { Component } from "react"
import "./App.css"
import NFTWallet from './NFTWallet'

class LambdaDemo extends Component {
  constructor(props) {
    super(props)
    this.state = { loading: false, msg: null }
  }

  handleClick = api => e => {
    e.preventDefault()

    this.setState({ loading: true })
    fetch("/.netlify/functions/" + api)
      .then(response => response.json())
      .then(json => this.setState({ loading: false, msg: json.msg }))
  }

  render() {
    const { loading, msg } = this.state

    return (
      <p>
        <button onClick={this.handleClick("hello")}>{loading ? "Loading..." : "Call Lambda"}</button>
        <button onClick={this.handleClick("async-dadjoke")}>{loading ? "Loading..." : "Call Async Lambda"}</button>
        <br />
        <span>{msg}</span>
      </p>
    )
  }
}

class App extends Component {

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="logo_container">
            <img className="logoimgage" src="logotipo.png"></img>
            <h2>
              Bienvenido a la web3 de Ingenia
            </h2>
          </div>
        </header>
        <NFTWallet></NFTWallet>
      </div>
    )
  }
}

export default App
